/**
 * Fields Module
 *
 */

angular
  .module('fields', ['ngResource', 'ngRoute'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider
      .when(CONFIG.url.fields.all(), {controller: 'FieldCtrl', templateUrl: '/r/static/templates/fields/all.html'})
      .when(CONFIG.url.fields.add(), {controller: 'FieldEditCtrl', templateUrl: '/r/static/templates/fields/edit.html'})
      .when(CONFIG.url.fields.edit(':id'), {
        controller: 'FieldEditCtrl',
        templateUrl: '/r/static/templates/fields/edit.html',
      })
  }])
  .factory('Field', ['$resource', function ($resource) {
    var Field = $resource(
      CONFIG.api('fields'),
      {},
      {
        reorder: {method: 'POST', isArray: false, params: {id: 'reorder'}},
      },
    )
    return Field
  }])

/* Controllers */

angular.module('fields').controller('FieldCtrl', ['$scope', '$rootScope', 'Field', function ($scope, $rootScope, Field) {
  $scope.utils.setPageTitle(_('breadcrumb_custom_fields'))
  $scope.utils.setPageID('members')

  $scope.fields = Field.query(
    {
      id: 'all',
      all_headings: true,
    },
    function () {
      a4.loaded($scope)
    },
    a4.restErrorFactory($scope),
  )

  // Dupe in both controllers, where to put it?
  $scope.visibilityValues = [
    {
      value: '0',
      name: _('field_visibility_invisible'),
    },
    {
      value: '1',
      name: _('field_visibility_visible'),
    },
    {
      value: '2',
      name: _('field_visibility_editable'),
    },
    {
      value: '3',
      name: _('field_visibility_required'),
    },
  ]

  // FB:121234 (also in groups.js)
  $('body').css('overflow-y', 'inherit')

  // Mostly duplicated from group controller
  var _get_order = function () {
    return $.map(
      $.grep($scope.fields, function (e) {
        return e.id
      }),
      function (e) {
        return e.id
      },
    )
  }
  var old_order

  $scope.sortableOptions = {
    cursor: 'move',
    containment: '.page-content',
    handle: '.handle',
    helper: function (e, tr) {
      var $originals = tr.children()
      var $helper = tr.clone()
      $helper.children().each(function (index) {
        // Set helper cell sizes to match the original sizes
        $(this).width($originals.eq(index).width() + 16)
      })
      $helper.addClass('sort-row')
      return $helper
    },
    start: function (/* e, ui */) {
      old_order = JSON.stringify(_get_order())
    },
    stop: function (/* e, ui */) {
      var o = _get_order()
      if (JSON.stringify(o) === old_order) {
        return
      }

      //TODO show loader

      Field.reorder(
        {order: o},
        // success handler
        function (/* data */) {
          $scope.notify.instant($rootScope, _('HTML_notification_field_order_saved'))
        },
        // error handler
        a4.restErrorFactory($scope),
      )
    },
  }
  // on touch devices, only allow dragging from the handle
  if ('ontouchend' in document) {
    $scope.sortableOptions.handle = '.handle'
  }
}])

angular.module('fields').controller('FieldEditCtrl', ['$scope', '$location', '$routeParams', 'Field', function ($scope, $location, $routeParams, Field) {
  $scope.utils.setPageID('members')

  $scope.visibilityValues = [
    {
      value: '0',
      name: _('field_visibility_invisible'),
    },
    {
      value: '1',
      name: _('field_visibility_visible'),
    },
    {
      value: '2',
      name: _('field_visibility_editable'),
    },
    {
      value: '3',
      name: _('field_visibility_required'),
    },
  ]

  // If we are editing then get the Field, else create empty one
  if ($routeParams.id) {
    $scope.utils.setPageTitle(_('field_edit_custom_field'))
    Field.get(
      {id: $routeParams.id},
      function (field) {
        if (field.type === 'dropdown') {
          var options = []
          for (var i = 0; i < field.options.length; i++) {
            options.push({name: field.options[i].label, remove: false})
          }
          field.options = options
        }
        $scope.field = field

        $scope.field.newFieldOption = ''

        $scope.filtered_vis = []
        $.each($scope.visibilityValues, function (k, v) {
          if ($.inArray(v.value, $scope.field.visibility_options) !== -1) {
            $scope.filtered_vis.push(v)
          }
        })

        a4.loaded($scope)
      },
      a4.restErrorFactory($scope),
    )
  } else {
    $scope.utils.setPageTitle(_('field_add_new_field'))
    $scope.field = new Field({type: 'text', visibility: '2'})
    $scope.filtered_vis = jQuery.extend({}, $scope.visibilityValues)

    $scope.field.options = []

    a4.loaded($scope)
  }

  $scope.addFieldOption = function () {
    var _newOption = $.trim($scope.field.newFieldOption)
    if (_newOption.length > 0) {
      $scope.field.options.push({name: _newOption, remove: false})
      $scope.field.newFieldOption = ''
    }
  }

  $scope.removeFieldOption = function (name) {
    $.each($scope.field.options, function (i, o) {
      if (name === o.name) {
        // If editing then just mark for removal
        if ($scope.field.id) {
          o.remove = !o.remove
        }
        // If adding a new field just remove the option
        else {
          $scope.field.options.splice(i, 1)
          return false
        }
      }
    })
  }

  $scope.fieldTypes = [
    {
      value: 'text',
      name: _('field_type_text'),
    },
    {
      value: 'date',
      name: _('field_type_date'),
    },
    {
      value: 'heading',
      name: _('field_type_heading'),
    },
    {
      value: 'checkbox',
      name: _('field_type_checkbox'),
    },
    {
      value: 'textarea',
      name: _('field_type_textarea'),
    },
    {
      value: 'integer',
      name: _('field_type_integer'),
    },
    {
      value: 'decimal',
      name: _('field_type_decimal'),
    },
    {
      value: 'dropdown',
      name: _('field_type_dropdown'),
    },
  ]

  $scope.save = a4.saveFactory($scope, function () {
    delete $scope.field.newFieldOption
    $scope.field.$save(
      {id: $scope.field.id},
      // success handler
      function () {
        if ($routeParams.id) {
          $scope.notify.set($scope, _('HTML_notification_field_edited'))
        } else {
          $scope.notify.set($scope, _('HTML_notification_field_added'))
        }
        $location.path(CONFIG.url.fields.all())
      },
      // error handler
      a4.restErrorFactory($scope),
    )
  })

  $scope.cancel = function () {
    $location.path(CONFIG.url.fields.all())
  }

  $scope['delete'] = function () {
    var confirmWord = _('js_field_delete_confirm_word')
    var promptMessage = _('js_field_delete_confirm') + '\n\n' + _('js_field_delete_prompt_instruction', {word: confirmWord})
    var userInput = prompt(promptMessage)

    if (userInput === null) {
      return
    }

    if (userInput.trim().toUpperCase() !== confirmWord.toUpperCase()) {
      alert(_('js_field_delete_wrong_word'))
      return
    }

    $scope.field.$delete(
      {id: $scope.field.id},
      // success handler
      function () {
        $scope.notify.set($scope, _('HTML_notification_field_deleted'))
        $location.path(CONFIG.url.fields.all())
      },
      // error handler
      a4.restErrorFactory($scope),
    )
  }
}])
